import { computed, inject, Injectable } from '@angular/core';

import { injectDevFlag } from '@core/dev-flags-logic';
import { DevFlag } from '@core/dev-flags-types';
import { FeatureSpecFacade } from '@core/feature-spec-logic';
import { FeatureCode } from '@core/feature-spec-types';

@Injectable({ providedIn: 'root' })
export class HireAssistantAccessService {
  private readonly featureSpecFacade = inject(FeatureSpecFacade);

  private readonly hasAiCandidateRecommendationsFlag = injectDevFlag(
    DevFlag.AiCandidateRecommendations,
  );

  public isAiScreeningEnabled = this.featureSpecFacade.selectIsEnabled(
    FeatureCode.AiCandidateScreening,
  );
  public isAiRecommendationsEnabled = this.featureSpecFacade.selectIsEnabled(
    FeatureCode.AiCandidateRecommendations,
  );

  public hasHireAssistant = computed(
    () =>
      this.hasAiCandidateRecommendationsFlag &&
      (this.isAiScreeningEnabled() || this.isAiRecommendationsEnabled()),
  );
}
